import * as React from 'react';
import { type VariantProps, cva } from 'class-variance-authority';
import { Toggle as TogglePrimitive } from 'radix-ui';
import { cn } from '@/lib/utils';

const toggleVariants = cva(
  'inline-flex items-center justify-center rounded-md text-sm font-medium text-icon-base transition-colors focus-within:outline-none hover:bg-ui-medium focus-visible:bg-black/4 focus-visible:bg-black/4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 dark:hover:bg-neutral-800 dark:focus-visible:bg-white/4',
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        outline:
          'border border-neutral-200 bg-transparent shadow-xs hover:bg-neutral-100 hover:text-neutral-900 dark:border-neutral-800 dark:hover:bg-neutral-800 dark:hover:text-neutral-50',
      },
      size: {
        default: 'h-9 px-3',
        sm: 'icon-8 p-0',
        lg: 'h-10 px-3',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> & VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root ref={ref} className={cn(toggleVariants({ variant, size, className }))} {...props} />
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
